/**LEA ./globals.md */

import { BehaviorSubject, Observable } from "rxjs";

import { cookies } from "kea-react";
import { State, initial } from "./state";
import { mapObject } from "keautils";

const cookieKey = "__app_global_state";

export interface Action {
    (prev: State): State
}
/**Estado global de la aplicación. Puede consumir estos valores directamente o utilizando el @see componentToRx para crear componentes que reaccionen a la documentación */
const subject = new BehaviorSubject<State>(cookies.Get(cookieKey) || initial);
export const state: Observable<State> = subject.map(x => {
    const ret = { ...initial, ...x };
    return ret;
});

function pushAction(action: Action) {
    subject.next(action(subject.value as State));
}

/**Publica un cambio en el state, su comportamiento es similar al setState de react*/
export async function setState(action: Action | Partial<State>) {
    if (typeof action == "function") {
        pushAction(action);
    } else {
        pushAction(prev => ({ ...prev, ...action }))
    }
}

/**Nos subscribimos a los cambios de state para estarlos almacenando en los cookies*/
state.subscribe(state => {
    cookies.Set(cookieKey, state)
});

/**Obtiene el valor actual del state. Siempre prefiera utilizar al observable state para que la aplicación se mantenga reactiva */
export async function getState() : Promise<State> {
    const data = cookies.Get(cookieKey);
    return data;
}



// WEBPACK FOOTER //
// ./app/resources/globals.ts